var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 793.70135 229.78532",
    height: 229.78532,
    width: 793.70135,
    xmlSpace: "preserve",
    id: "svg2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath28",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path26",
    d: "M 0,172.339 H 595.276 V 0 H 0 Z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333333,0,0,-1.3333333,0,229.78533)",
    id: "g10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path12",
    style: {
      fill: "#1f9c9f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 533.11,42.473 h -6.133 v 35.896 h 6.133 z m 11.29,30.952 h -28.571 v 4.941 H 544.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path14",
    style: {
      fill: "#1f9c9f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 512.798,42.473 h -19.049 v 4.905 h 19.049 z m -17.315,0 h -6.205 v 35.896 h 6.205 z m 14.827,16.09 h -16.557 v 4.833 h 16.557 z m 2.38,14.862 h -18.941 v 4.941 h 18.941 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path16",
    style: {
      fill: "#1f9c9f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 473.296,42.473 h -6.133 v 35.896 h 6.133 z m 11.257,30.952 h -28.571 v 4.941 h 28.571 z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(429.7176,52.5747)",
    id: "g18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path20",
    style: {
      fill: "#1f9c9f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 15.946,25.831 h 6.205 V -10.065 H 15.946 V 15.763 L 0,-10.065 H -6.169 V 25.831 H 0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g22"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath28)",
    id: "g24"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(411.8243,54.1622)",
    id: "g30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path32",
    style: {
      fill: "#1f9c9f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 h 6.169 c -0.18,-2.345 -0.866,-4.438 -1.986,-6.277 -1.117,-1.841 -2.668,-3.246 -4.725,-4.33 -2.018,-1.045 -4.474,-1.587 -7.358,-1.587 -2.237,0 -4.222,0.398 -5.989,1.192 -1.767,0.794 -3.282,1.946 -4.582,3.39 -1.263,1.479 -2.237,3.246 -2.922,5.339 -0.65,2.093 -0.974,4.438 -0.974,6.998 V 7.72 c 0,2.596 0.324,4.905 1.009,6.998 0.686,2.094 1.695,3.86 2.959,5.34 1.264,1.479 2.815,2.632 4.618,3.425 1.803,0.794 3.824,1.192 6.097,1.192 2.851,0 5.267,-0.542 7.25,-1.587 1.985,-1.045 3.5,-2.488 4.581,-4.366 1.121,-1.874 1.77,-4.004 2.022,-6.384 H 0 c -0.144,1.551 -0.542,2.887 -1.081,3.967 -0.542,1.121 -1.336,1.95 -2.42,2.525 -1.081,0.578 -2.452,0.904 -4.183,0.904 -1.408,0 -2.632,-0.254 -3.681,-0.793 -1.045,-0.542 -1.946,-1.3 -2.632,-2.309 -0.721,-1.012 -1.228,-2.273 -1.587,-3.788 C -15.946,11.365 -16.09,9.67 -16.09,7.756 V 4.725 c 0,-1.802 0.144,-3.461 0.47,-4.941 0.324,-1.479 0.83,-2.707 1.48,-3.788 0.685,-1.048 1.515,-1.877 2.56,-2.452 1.045,-0.578 2.273,-0.869 3.716,-0.869 1.767,0 3.174,0.291 4.255,0.833 1.121,0.539 1.95,1.368 2.492,2.452 C -0.578,-2.887 -0.18,-1.551 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(371.9971,55.8577)",
    id: "g34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path36",
    style: {
      fill: "#1f9c9f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 H -9.343 V 4.905 H 0 c 1.623,0 2.959,0.255 3.932,0.794 1.009,0.542 1.731,1.263 2.201,2.165 0.47,0.937 0.722,2.021 0.722,3.21 0,1.12 -0.252,2.201 -0.722,3.174 -0.47,1.012 -1.192,1.806 -2.201,2.42 C 2.923,17.279 1.623,17.569 0,17.569 h -7.433 v -30.988 h -6.204 V 22.474 H 0 c 2.779,0 5.124,-0.506 7.07,-1.479 1.95,-0.973 3.429,-2.309 4.474,-4.04 1.009,-1.695 1.515,-3.68 1.515,-5.881 0,-2.309 -0.506,-4.291 -1.515,-5.95 C 10.535,3.462 9.056,2.201 7.07,1.3 5.124,0.434 2.779,0 0,0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path38",
    style: {
      fill: "#1f9c9f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 353.309,42.473 H 334.26 v 4.905 h 19.049 z m -17.315,0 h -6.205 v 35.896 h 6.205 z m 14.827,16.09 h -16.557 v 4.833 h 16.557 z m 2.344,14.862 h -18.941 v 4.941 h 18.941 z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(311.3549,58.7077)",
    id: "g40"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path42",
    style: {
      fill: "#1f9c9f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 h -9.163 l -0.036,4.51 h 7.971 c 1.336,0 2.492,0.179 3.429,0.578 0.937,0.395 1.659,1.009 2.165,1.767 0.503,0.757 0.722,1.695 0.722,2.775 0,1.192 -0.219,2.166 -0.686,2.923 -0.47,0.758 -1.156,1.3 -2.129,1.659 -0.937,0.363 -2.129,0.506 -3.609,0.506 H -7.322 V -16.27 h -6.208 v 35.893 h 12.194 c 1.986,0 3.717,-0.179 5.268,-0.574 1.551,-0.363 2.887,-0.977 3.968,-1.77 1.12,-0.794 1.949,-1.803 2.488,-2.992 0.578,-1.228 0.869,-2.671 0.869,-4.33 0,-1.479 -0.363,-2.851 -1.048,-4.075 C 9.487,4.654 8.442,3.68 7.07,2.887 5.699,2.129 3.968,1.659 1.91,1.515 Z M -0.287,-16.234 H -11.11 l 2.776,4.905 h 8.047 c 1.404,0 2.56,0.219 3.497,0.686 0.937,0.47 1.623,1.12 2.093,1.95 0.467,0.829 0.722,1.802 0.722,2.923 0,1.152 -0.215,2.161 -0.614,3.027 C 5.013,-1.874 4.366,-1.192 3.462,-0.758 2.56,-0.287 1.408,-0.036 0,-0.036 h -6.962 l 0.036,4.51 H 2.129 L 3.537,2.779 c 1.982,-0.072 3.605,-0.506 4.869,-1.3 1.3,-0.793 2.237,-1.838 2.851,-3.138 0.61,-1.3 0.937,-2.671 0.937,-4.151 0,-2.269 -0.506,-4.183 -1.515,-5.734 -0.973,-1.551 -2.417,-2.704 -4.259,-3.537 -1.838,-0.758 -4.075,-1.153 -6.707,-1.153"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(268.3535,52.5747)",
    id: "g44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path46",
    style: {
      fill: "#1f9c9f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 15.946,25.831 h 6.205 V -10.065 H 15.946 V 15.763 L 0,-10.065 H -6.169 V 25.831 H 0 Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path48",
    style: {
      fill: "#1f9c9f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 250.101,58.491 h -19.049 v 4.905 h 19.049 z M 232.567,42.473 h -6.205 v 35.896 h 6.205 z m 22.295,0 h -6.169 v 35.896 h 6.169 z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(205.6907,54.992)",
    id: "g50"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path52",
    style: {
      fill: "#1f9c9f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 9.128,23.412 h 6.818 L 3.462,-5.989 c -0.396,-0.902 -0.83,-1.767 -1.369,-2.632 -0.506,-0.83 -1.084,-1.587 -1.806,-2.237 -0.721,-0.65 -1.551,-1.192 -2.56,-1.587 -1.009,-0.363 -2.237,-0.578 -3.644,-0.578 -0.36,0 -0.83,0 -1.369,0.035 -0.542,0.036 -0.904,0.072 -1.156,0.108 l 0.036,4.873 c 0.18,-0.036 0.542,-0.072 0.973,-0.072 0.471,0 0.83,-0.039 1.049,-0.039 0.937,0 1.694,0.146 2.273,0.47 0.538,0.323 1.009,0.757 1.332,1.3 0.362,0.538 0.65,1.152 0.904,1.838 z m -6.855,23.376 9.02,-19.875 1.767,-6.46 -4.797,-0.179 -12.737,26.514 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(523.5148,103.2242)",
    id: "g54"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path56",
    style: {
      fill: "#1f9c9f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 15.449,25.027 h 6.012 V -9.751 H 15.449 V 15.272 L 0,-9.751 h -5.977 v 34.74 H 0 Z m 11.324,33.902 h 4.265 c 0,-1.326 -0.317,-2.481 -0.943,-3.493 -0.63,-1.016 -1.503,-1.785 -2.693,-2.377 -1.155,-0.56 -2.515,-0.876 -4.125,-0.876 -2.411,0 -4.297,0.63 -5.695,1.854 -1.399,1.259 -2.098,2.867 -2.098,4.857 H 4.3 c 0,-0.908 0.278,-1.677 0.803,-2.376 0.56,-0.665 1.468,-1.013 2.725,-1.013 1.259,0 2.167,0.348 2.692,1.013 0.525,0.734 0.804,1.537 0.804,2.411"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(488.9827,103.2242)",
    id: "g58"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path60",
    style: {
      fill: "#1f9c9f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 15.449,25.027 h 6.012 V -9.751 H 15.449 V 15.272 L 0,-9.751 h -5.977 v 34.74 H 0 Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path62",
    style: {
      fill: "#1f9c9f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 457.597,93.437 h -5.977 v 34.778 h 5.977 z m 20.936,34.778 -14.156,-19.819 h -8.457 l -0.804,5.208 h 5.977 l 10.134,14.611 z m -6.116,-34.778 -11.254,15.87 3.879,4.613 14.573,-20.483 z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(440.0861,104.7619)",
    id: "g64"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path66",
    style: {
      fill: "#1f9c9f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 H 5.977 C 5.803,-2.272 5.138,-4.3 4.053,-6.081 2.971,-7.866 1.468,-9.226 -0.525,-10.276 c -1.955,-1.013 -4.335,-1.538 -7.129,-1.538 -2.167,0 -4.091,0.386 -5.802,1.155 -1.712,0.769 -3.18,1.885 -4.404,3.284 -1.225,1.433 -2.168,3.145 -2.832,5.173 -0.63,2.028 -0.943,4.3 -0.943,6.78 V 7.48 c 0,2.515 0.313,4.752 0.978,6.78 0.664,2.028 1.645,3.74 2.866,5.173 1.259,1.433 2.728,2.55 4.474,3.319 1.75,0.769 3.705,1.155 5.907,1.155 2.762,0 5.103,-0.526 7.027,-1.538 1.921,-1.012 3.389,-2.411 4.436,-4.23 1.085,-1.781 1.715,-3.879 1.958,-6.186 H 0.035 c -0.174,1.503 -0.525,2.797 -1.047,3.845 -0.526,1.085 -1.295,1.888 -2.342,2.445 -1.05,0.56 -2.379,0.877 -4.056,0.877 -1.364,0 -2.55,-0.247 -3.566,-0.769 -1.012,-0.525 -1.885,-1.259 -2.55,-2.237 -0.699,-0.981 -1.189,-2.202 -1.537,-3.67 -0.352,-1.434 -0.491,-3.076 -0.491,-4.93 V 4.578 c 0,-1.746 0.139,-3.354 0.456,-4.787 0.313,-1.433 0.803,-2.623 1.433,-3.67 0.664,-1.016 1.468,-1.819 2.48,-2.376 1.013,-0.56 2.203,-0.839 3.601,-0.839 1.712,0 3.075,0.279 4.123,0.804 1.085,0.522 1.889,1.326 2.414,2.376 C -0.525,-2.797 -0.174,-1.503 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(401.6747,109.1658)",
    id: "g68"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path70",
    style: {
      fill: "#1f9c9f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 h -8.878 l -0.035,4.369 h 7.723 c 1.294,0 2.414,0.174 3.323,0.56 0.908,0.383 1.642,0.978 2.097,1.712 0.487,0.734 0.734,1.642 0.734,2.689 0,1.155 -0.212,2.098 -0.664,2.832 -0.456,0.734 -1.12,1.259 -2.063,1.607 -0.908,0.352 -2.063,0.491 -3.496,0.491 h -5.8 v -30.023 h -6.014 v 34.81 h 11.814 c 1.923,0 3.6,-0.174 5.103,-0.557 1.503,-0.351 2.797,-0.946 3.844,-1.715 1.051,-0.769 1.854,-1.746 2.414,-2.898 0.557,-1.19 0.839,-2.588 0.839,-4.195 C 10.941,8.248 10.59,6.92 9.925,5.733 9.226,4.543 8.214,3.601 6.885,2.832 5.556,2.098 3.879,1.642 1.889,1.503 Z m -0.244,-15.728 h -10.485 l 2.689,4.752 h 7.796 c 1.361,0 2.481,0.212 3.389,0.665 0.908,0.455 1.572,1.085 2.028,1.889 0.456,0.803 0.699,1.746 0.699,2.831 0,1.117 -0.209,2.095 -0.595,2.933 -0.382,0.842 -1.012,1.503 -1.885,1.924 -0.877,0.456 -1.994,0.699 -3.357,0.699 h -6.746 l 0.035,4.37 H 2.098 L 3.461,2.693 c 1.921,-0.07 3.493,-0.491 4.718,-1.26 1.259,-0.769 2.167,-1.781 2.762,-3.04 0.591,-1.26 0.908,-2.588 0.908,-4.022 0,-2.199 -0.491,-4.053 -1.468,-5.556 -0.943,-1.502 -2.342,-2.619 -4.126,-3.426 -1.816,-0.734 -3.983,-1.117 -6.499,-1.117"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(382.6262,111.7871)",
    id: "g72"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path74",
    style: {
      fill: "#1f9c9f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 v -1.924 c 0,-2.619 -0.348,-4.996 -1.012,-7.058 -0.7,-2.098 -1.681,-3.879 -2.937,-5.313 -1.259,-1.468 -2.762,-2.588 -4.543,-3.357 -1.784,-0.768 -3.74,-1.151 -5.872,-1.151 -2.133,0 -4.091,0.383 -5.838,1.151 -1.746,0.769 -3.284,1.889 -4.578,3.357 -1.294,1.468 -2.306,3.25 -3.006,5.313 -0.699,2.097 -1.05,4.439 -1.05,7.058 V 0 c 0,2.623 0.351,4.964 1.05,7.059 0.7,2.097 1.677,3.882 2.971,5.315 1.294,1.468 2.797,2.62 4.579,3.354 1.781,0.769 3.704,1.155 5.837,1.155 2.167,0 4.123,-0.386 5.872,-1.155 1.782,-0.769 3.284,-1.886 4.578,-3.354 1.256,-1.468 2.237,-3.252 2.937,-5.315 C -0.348,4.964 0,2.623 0,0 m -5.977,-1.924 v 1.959 c 0,1.958 -0.174,3.67 -0.56,5.138 -0.348,1.503 -0.908,2.762 -1.642,3.74 -0.734,1.012 -1.607,1.781 -2.654,2.306 -1.051,0.526 -2.237,0.804 -3.566,0.804 -1.329,0 -2.518,-0.278 -3.531,-0.804 -1.047,-0.525 -1.924,-1.259 -2.658,-2.306 -0.734,-1.013 -1.256,-2.237 -1.642,-3.74 -0.383,-1.468 -0.557,-3.18 -0.557,-5.138 v -1.959 c 0,-1.955 0.174,-3.667 0.557,-5.173 0.386,-1.503 0.946,-2.759 1.68,-3.809 0.731,-1.013 1.642,-1.781 2.69,-2.307 1.05,-0.522 2.202,-0.768 3.531,-0.768 1.328,0 2.515,0.246 3.565,0.768 1.048,0.526 1.921,1.294 2.62,2.307 0.734,1.05 1.259,2.306 1.607,3.809 0.352,1.506 0.56,3.253 0.56,5.173"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(351.5197,128.2142)",
    id: "g76"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path78",
    style: {
      fill: "#1f9c9f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 v -4.787 h -16.149 v -30.026 h -5.976 V 0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(323.2791,111.7871)",
    id: "g80"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path82",
    style: {
      fill: "#1f9c9f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 v -1.924 c 0,-2.619 -0.348,-4.996 -1.012,-7.058 -0.7,-2.098 -1.681,-3.879 -2.937,-5.313 -1.259,-1.468 -2.762,-2.588 -4.543,-3.357 -1.784,-0.768 -3.74,-1.151 -5.872,-1.151 -2.133,0 -4.091,0.383 -5.838,1.151 -1.746,0.769 -3.284,1.889 -4.578,3.357 -1.294,1.468 -2.306,3.25 -3.006,5.313 -0.699,2.097 -1.05,4.439 -1.05,7.058 V 0 c 0,2.623 0.351,4.964 1.05,7.059 0.7,2.097 1.677,3.882 2.971,5.315 1.294,1.468 2.797,2.62 4.579,3.354 1.781,0.769 3.704,1.155 5.837,1.155 2.167,0 4.123,-0.386 5.872,-1.155 1.782,-0.769 3.284,-1.886 4.578,-3.354 1.256,-1.468 2.237,-3.252 2.937,-5.315 C -0.348,4.964 0,2.623 0,0 m -5.977,-1.924 v 1.959 c 0,1.958 -0.174,3.67 -0.56,5.138 -0.348,1.503 -0.908,2.762 -1.642,3.74 -0.734,1.012 -1.607,1.781 -2.654,2.306 -1.051,0.526 -2.24,0.804 -3.566,0.804 -1.329,0 -2.518,-0.278 -3.531,-0.804 -1.047,-0.525 -1.924,-1.259 -2.658,-2.306 -0.734,-1.013 -1.256,-2.237 -1.642,-3.74 -0.383,-1.468 -0.557,-3.18 -0.557,-5.138 v -1.959 c 0,-1.955 0.174,-3.667 0.557,-5.173 0.386,-1.503 0.946,-2.759 1.677,-3.809 0.734,-1.013 1.645,-1.781 2.693,-2.307 1.047,-0.522 2.202,-0.768 3.531,-0.768 1.328,0 2.515,0.246 3.565,0.768 1.048,0.526 1.921,1.294 2.62,2.307 0.734,1.05 1.259,2.306 1.607,3.809 0.352,1.506 0.56,3.253 0.56,5.173"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(277.4929,106.4046)",
    id: "g84"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path86",
    style: {
      fill: "#1f9c9f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 H -9.052 V 4.752 H 0 c 1.572,0 2.867,0.247 3.809,0.769 0.978,0.525 1.677,1.224 2.133,2.098 0.455,0.908 0.699,1.958 0.699,3.11 0,1.085 -0.244,2.132 -0.699,3.075 -0.456,0.981 -1.155,1.75 -2.133,2.345 C 2.832,16.74 1.572,17.022 0,17.022 h -7.201 v -30.023 h -6.012 v 34.81 H 0 c 2.693,0 4.964,-0.487 6.85,-1.433 1.889,-0.943 3.322,-2.237 4.335,-3.914 0.977,-1.642 1.468,-3.566 1.468,-5.698 0,-2.237 -0.491,-4.158 -1.468,-5.765 C 10.207,3.392 8.739,2.167 6.85,1.294 4.999,0.421 2.693,0 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(235.6562,103.2242)",
    id: "g88"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path90",
    style: {
      fill: "#1f9c9f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 15.449,24.989 h 6.012 V -9.786 H 15.449 V 15.238 L 0,-9.786 H -5.977 V 24.989 H 0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(222.5145,128.2142)",
    id: "g92"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path94",
    style: {
      fill: "#1f9c9f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 v -34.778 h -5.977 v 30.026 h -15.449 v -30.026 h -5.977 V 0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(94.463,124.8121)",
    id: "g96"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path98",
    style: {
      fill: "#e83a69",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c -25.618,35.022 -61.409,26.634 -61.409,26.634 v -61.899 h 9.995 10.207 V 5.347 c 33.902,-9.786 31.07,-40.577 31.07,-40.577 h 9.998 10.169 c 0,0 -2.829,30.687 31.073,40.577 V -35.23 H 51.097 61.27 V 26.634 C 61.27,26.634 25.618,34.917 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(155.8372,82.6259)",
    id: "g100"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path102",
    style: {
      fill: "#1f9c9f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 h -10.276 l -10.277,0.139 c 0.734,-24.394 -15.098,-37.258 -26.84,-41.45 -6.571,-2.342 -12.269,-2.589 -13.737,-2.589 h -0.488 c -1.468,0 -7.166,0.14 -13.737,2.589 -11.745,4.192 -27.473,17.091 -26.843,41.45 h -10.311 L -122.783,0 c 0,0 -1.12,-11.254 3.598,-24.011 6.432,-17.686 24.64,-38.866 57.321,-40.229 h 0.734 c 32.68,1.468 50.993,22.647 57.321,40.229 C 1.012,-11.254 0,0 0,0"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b097d2d098f585d1285f24cef4bd3770.svg";
export { ForwardRef as ReactComponent };